import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-date-calendar-vuepic" }

import '@vuepic/vue-datepicker/dist/main.css'

/**
 * Calendar for InlineDateEditor on top of VueDatePicker. The only file that knows about
 * this library, and the whole contract with the editor is the props and the events
 * below. Another calendar, our own or a third party one, is plugged in by a file with
 * the same contract and nothing else changes.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'InlineDateCalendarVuepic',
  props: {
    modelValue: {},
    minDate: { default: undefined },
    maxDate: { default: undefined },
    withTime: { type: Boolean, default: false },
    options: { default: () => ({}) }
  },
  emits: ["select", "close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const onPick = (value: Date | null) => {
	emit('select', value)
	emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VueDatePicker, _mergeProps({
      "model-value": _ctx.modelValue,
      locale: _ctx.$i18n.locale,
      "min-date": _ctx.minDate,
      "max-date": _ctx.maxDate,
      "enable-time-picker": _ctx.withTime,
      inline: true,
      teleport: false,
      "auto-apply": !_ctx.withTime
    }, _ctx.options, { "onUpdate:modelValue": onPick }), null, 16, ["model-value", "locale", "min-date", "max-date", "enable-time-picker", "auto-apply"])
  ]))
}
}

})